<template>
  <div class="deactivate-delaer-company">
    <v-dialog v-model="dialog" max-width="450" persistent>
      <v-card>
        <v-card-text>
          <div class="d-flex justify-space-between pt-2">
            <h3 class="black--text">Deactivate {{ dealerInfo.name }}?</h3>
            <v-icon @click="$emit('close')">mdi-close</v-icon>
          </div>
          <v-divider class="black--text"></v-divider>

          <div>
            <ul class="px-2 mb-2">
              <li>Dealer Company will no longer be able to sign in.</li>
              <li>Post or edit schedules</li>
              <li>Dealer Company can be reactivated</li>
            </ul>

            <v-btn
              color="red"
              class="white--text mr-1"
              depressed
              :loading="loading"
              @click="updateDealer"
              >Deactivate</v-btn
            >
            <v-btn
              color="black"
              :disabled="loading"
              outlined
              depressed
              @click="$emit('close')"
              >Cancel</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    dealerInfo: {
      type: Object,
      default: null,
      required: true
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    updateDealer() {
      this.loading = true;
      const payload = {
        ...this.dealerInfo,
        logo: {
          base64: null,
          file_type: null
        },
        is_suspended: true
      };

      delete payload.logo_url;

      this.$store
        .dispatch("dealer/updateDealerCompany", payload)
        .then(() => {
          this.$emit("refresh");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
